import { apiClient } from '@/lib/apiClient';

import type { Informe, InformeFinalEmitido } from './types';

export const informesApi = {
  /**
   * GET /protocolos/{uid}/informe-parcial
   * Regenera el PDF cada vez. Bloqueado si el final ya fue emitido.
   */
  async getParcial(uidProtocolo: string, signal?: AbortSignal): Promise<Informe> {
    const response = await apiClient.get<Informe>(
      `/protocolos/${uidProtocolo}/informe-parcial`,
      { signal }
    );
    return response.data;
  },

  /**
   * POST /protocolos/{uid}/informe-final/emitir
   * Irreversible — marca informe_final_emitido=true. Status 201.
   */
  async emitirFinal(uidProtocolo: string, signal?: AbortSignal): Promise<InformeFinalEmitido> {
    const response = await apiClient.post<InformeFinalEmitido>(
      `/protocolos/${uidProtocolo}/informe-final/emitir`,
      {},
      { signal }
    );
    return response.data;
  },

  /**
   * GET /protocolos/{uid}/informe-final
   * 404 si no fue emitido. No incluye fecha_emision (solo el POST /emitir la retorna).
   */
  async getFinal(uidProtocolo: string, signal?: AbortSignal): Promise<Informe> {
    const response = await apiClient.get<Informe>(
      `/protocolos/${uidProtocolo}/informe-final`,
      { signal }
    );
    return response.data;
  },
};
